import { render, staticRenderFns } from "./systemCorporate.vue?vue&type=template&id=0b398601"
import script from "./systemCorporate.vue?vue&type=script&lang=js"
export * from "./systemCorporate.vue?vue&type=script&lang=js"
import style0 from "./systemCorporate.vue?vue&type=style&index=0&id=0b398601&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports